import React, { useEffect, useState } from "react"
import { Button, Card, Grid } from "@mui/material"
import { WBInput, WBSelect } from "components/_WBcomponents/WBInput"
import { statusOptions } from "helper/constant"
import { loadUser } from "services/userService"
import { getEventList } from "services/eventService"

function ProductFilter ({
    filter,
    onChangeFilter,
    onClear
}) {

    const [ eventList, setEventList ] = useState([])

    useEffect(() => {
        loadEventList()
    }, [])

    const loadEventList = async () => {
        let { data, error } = await getEventList({ type: 'po' })
        if (error) { console.log(error) }
        if (data) {
            let dataList = []
            data.map(v => {
                dataList.push({
                    value: v._id,
                    label: v.eventName,
                    data: v
                })
            })
            setEventList(dataList)
        }
    }

    return (
        <Grid>
            <Grid container spacing={1}>
                <Grid item xs={12} sm={2}>
                    <WBInput label={"Sku Id"} 
                        value={filter.skuId}
                        onChange={(e) => {
                            onChangeFilter({skuId: e.currentTarget.value})
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <WBInput label={"Product Name"} value={filter.productName} onChange={(e) => { onChangeFilter({productName: e.currentTarget.value})}}/>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <WBSelect label={"PO Event"} 
                        options={eventList}
                        value={filter.event}
                        onChange={(e) => {
                            onChangeFilter({event: e})
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <WBSelect label={"Is Archived"} 
                        options={[
                            { label: "All", value: "" },
                            { label: "Archived", value: "false" }
                        ]}
                        value={filter.isActive}
                        onChange={(e) => {
                            onChangeFilter({isActive: e})
                        }}
                    />
                </Grid>
                <Grid item xs sm textAlign={"right"}>
                    <div style={{marginTop: 20}}/>
                    <Button variant="outlined" onClick={onClear}>Clear</Button>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default ProductFilter